<template>
  <div class="h-100 pb-3 d-flex flex-column">
    <div class="d-flex justify-content-end align-items-center py-2">
      <b-button-group
        size="sm"
        class="mr-auto"
      >
        <b-button
          :variant="viewMode === 'manager' ? 'soft-primary' : 'minimal-primary'"
          @click="viewMode = 'manager'"
        >
          <b-icon
            icon="layout-sidebar"
            class="mr-1"
          ></b-icon>
          {{ $t('vendorSitesTab.manageView') }}
        </b-button>
        <b-button
          :variant="viewMode === 'grid' ? 'soft-primary' : 'minimal-primary'"
          @click="viewMode = 'grid'"
        >
          <b-icon
            icon="table"
            class="mr-1"
          ></b-icon>
          {{ $t('vendorSitesTab.gridView') }}
        </b-button>
      </b-button-group>
      <b-button
        v-if="viewMode === 'grid'"
        variant="soft-success"
        size="sm"
        @click="onAddSite"
      >
        <b-icon
          icon="plus"
          class="mr-1"
        ></b-icon>
        {{ $t('vendorSitesTab.addSite') }}
      </b-button>
    </div>
    <!-- DEMO: sidebar + detail manager (throwaway) -->
    <company-sites-manager
      v-if="viewMode === 'manager'"
      :company-id="resource.id"
      class="flex-fill"
      @changed="$emit('resource:refresh')"
    ></company-sites-manager>
    <object-grid
      v-else
      ref="sitesGrid"
      model-class="CompanySite"
      flow-subtype=""
      class="h-100 flex-fill"
      grid-max-height="100%"
      :colStateLocalStorageKey="'vendorProfileSites'"
      :fixedFilterKwargs="fixedFilterKwargs"
      :excludeFields="excludeFields"
      :rowActions="rowActions"
      @action-click="onActionClick"
    ></object-grid>
    <company-site-modal
      ref="siteModal"
      :company-id="resource.id"
      @saved="onSiteChanged"
      @deleted="onSiteChanged"
    ></company-site-modal>
  </div>
</template>

<script>
  import CompanySiteModal from '@/components/vendors/components/CompanySiteModal.vue';
  import CompanySitesManager from '@/components/vendors/components/CompanySitesManager.vue';

  // the Sites tab on the vendor page -- ONLY for tenants with custom_flags.use_vendor_sites (CompanySite instead of CompanyLocation)
  export default {
    name: 'VendorSitesTab',
    components: {
      CompanySiteModal,
      CompanySitesManager,
    },
    mixins: [],
    i18n: {
      messages: {
        en: {
          vendorSitesTab: {
            manageView: 'Manage',
            gridView: 'Grid',
            addSite: 'Add Site',
            edit: 'Edit',
          },
        },
        es: {
          vendorSitesTab: {
            manageView: 'Administrar',
            gridView: 'Cuadrícula',
            addSite: 'Agregar Sitio',
            edit: 'Editar',
          },
        },
        pt: {
          vendorSitesTab: {
            manageView: 'Gerenciar',
            gridView: 'Grade',
            addSite: 'Adicionar Unidade',
            edit: 'Editar',
          },
        },
        'zh-Hans': {
          vendorSitesTab: {
            manageView: '管理',
            gridView: '表格',
            addSite: '添加站点',
            edit: '编辑',
          },
        },
        'zh-Hant': {
          vendorSitesTab: {
            manageView: '管理',
            gridView: '表格',
            addSite: '新增據點',
            edit: '編輯',
          },
        },
      },
    },
    props: {
      resource: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        viewMode: 'manager', // 'manager' (CompanySitesManager -- demo) or 'grid' (ObjectGrid)
        excludeFields: ['company'], // works because we use fixedFilterKwargs
        fixedFilterKwargs: {
          company: this.resource.id,
        },
      };
    },
    computed: {
      rowActions() {
        return [{ key: 'edit', label: this.$t('vendorSitesTab.edit'), bsIcon: 'pencil', variant: 'primary' }];
      },
    },
    methods: {
      onAddSite() {
        this.$refs.siteModal.startCreate();
      },
      onActionClick(actionObj, rowData) {
        if (actionObj.key === 'edit') {
          this.$refs.siteModal.startUpdate(rowData.id);
        }
      },
      onSiteChanged() {
        this.$refs.sitesGrid?.reloadRows();
        this.$emit('resource:refresh'); // refetch the vendor -- the header shows the primary site's city/country
      },
    },
  };
</script>
